import { queryOptions, useQuery } from '@tanstack/react-query'

import { ApiPagedPayload } from '@/api/shared/types'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { NotificationsService } from '..'
import { NotificationsListPayload } from '../lib/notifications.types'

export const NOTIFICATIONS_LIST_RQ_KEY = 'notifications-list'

export const getNotificationsListOptions = ({
  projectId,
  page
}: ApiPagedPayload<NotificationsListPayload>) => {
  return queryOptions({
    queryKey: [NOTIFICATIONS_LIST_RQ_KEY, projectId, page],
    queryFn: () =>
      NotificationsService.getNotificationsList({ projectId, page }),
    select: response => response.data.data,
    enabled: Boolean(projectId),
    refetchInterval: 60 * 1000
  })
}

export const useNotificationsList = (payload: ApiPagedPayload = {}) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  return useQuery(getNotificationsListOptions({ projectId, ...payload }))
}
